import React from 'react';

const LoadingSpinner = ({ 
  size = 'md', 
  color = 'primary', 
  fullScreen = false, 
  message = 'Cargando...',
  showMessage = true 
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  const colorClasses = {
    primary: 'border-primary-500',
    secondary: 'border-secondary-500',
    success: 'border-success-500',
    warning: 'border-warning-500',
    error: 'border-error-500',
    white: 'border-white'
  };

  const spinnerClasses = `
    ${sizeClasses[size]} 
    border-2 
    ${colorClasses[color]} 
    border-t-transparent 
    rounded-full 
    animate-spin
  `;

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white bg-opacity-90 flex items-center justify-center z-50">
        <div className="text-center">
          <div className={spinnerClasses}></div>
          {showMessage && (
            <p className="mt-4 text-gray-600 font-medium">{message}</p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center p-4">
      <div className="text-center">
        <div className={spinnerClasses}></div>
        {showMessage && (
          <p className="mt-2 text-gray-600 text-sm">{message}</p>
        )}
      </div>
    </div>
  );
};

export default LoadingSpinner;